export default "__VITE_ASSET__BHqq4SxU__"